// authReducer.js

import { LOGIN_SUCCESS, LOGIN_FAIL, LOGOUT } from '../types';

const readStoredUser = () => {
  try {
    const stored = localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    // A corrupt entry must not stop the app from booting.
    return null;
  }
};

const storedToken = localStorage.getItem('token') || null;

const initialState = {
  token: storedToken,
  // This was hard-coded to false, so on a refresh the store disagreed with the
  // router, which was reading the token from localStorage directly.
  isLoggedIn: Boolean(storedToken),
  user: readStoredUser(),
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        token: action.payload.token,
        isLoggedIn: true,
        user: action.payload.user,
      };
    case LOGIN_FAIL:
    case LOGOUT:
      return {
        ...state,
        token: null,
        isLoggedIn: false,
        user: null,
      };
    default:
      return state;
  }
};

export default authReducer;
